"use strict";
window.isMobile = false;
window.$html = document.querySelector("html");
(function () {

	function getOrientation() {
		var portrait = false;
		if (window.matchMedia) {
			portrait = window.matchMedia("(orientation: portrait)").matches
		} else if (window.orientation && !isAndroid) {
			portrait = window.orientation === 0 || window.orientation === 180
		} else {
			portrait = window.innerHeight >= window.innerWidth;
		}
		return !portrait ? 'landscape' : 'portrait'
	}

	function isSafari() {
		var ua = navigator.userAgent.toLowerCase(); 
		if (ua.indexOf('safari') != -1 && ua.indexOf('chrome') == -1) {
			return true;
		} else {
			return false;
		}
	}

	// maybe http://hgoebl.github.io/mobile-detect.js/ is overkill !!!!!

	// http://detectmobilebrowsers.com/ (changed window.location=b ===> window.isMobile=true;)
	(function(a,b){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4)))window.isMobile=true;})(navigator.userAgent||navigator.vendor||window.opera,'http://detectmobilebrowser.com/mobile');

	function supportsTransitions() {
		var b = document.body || document.documentElement,
			s = b.style,
			p = 'transition';
		if (typeof s[p] == 'string') { return true; }
		// Tests for vendor specific prop
		var v = ['Moz', 'webkit', 'Webkit', 'Khtml', 'O', 'ms'];
		p = p.charAt(0).toUpperCase() + p.substr(1);

		for (var i=0; i<v.length; i++) {
			if (typeof s[v[i] + p] == 'string') { return true; }
		}
		return false;
	}

	/* from modernizr */
	function createElement() {
		if (typeof document.createElement !== 'function') {
			// This is the case in IE7, where the type of createElement is "object".
			// For this reason, we cannot call apply() as Object is not a Function.
			return document.createElement(arguments[0]);
		} else if (document.documentElement.nodeName.toLowerCase() === 'svg') {
			return document.createElementNS.call(document, 'http://www.w3.org/2000/svg', arguments[0]);
		} else {
			return document.createElement.apply(document, arguments);
		}
	}

	window.isEdge = /Edge/.test(navigator.userAgent);

	window.isIE11 = !(window.ActiveXObject) && "ActiveXObject" in window;
	window.isIE10 = false;
	/*@cc_on
		 if (/^10/.test(@_jscript_version)) {
				 isIE10 = true;
		 }
	@*/


	window.hasTransitions = supportsTransitions();
	window.isTouch = !!(typeof document.body.ontouchstart !== 'undefined' || typeof window.ontouchstart !== 'undefined' || typeof document.documentElement.ontouchstart !== 'undefined');
	window.isTablet = window.isTouch && (navigator.userAgent.match(/tablet|Android|BlackBerry|iPad|Opera Mini|IEMobile/i) !== null) && (window.innerWidth > 640) && (window.innerWidth < 1350);
	window.isiPad = window.isTouch && navigator.userAgent.match(/iPad/i) !== null && navigator.userAgent.match(/Android/i) == null;
	window.isiPhone = window.isTouch && window.isMobile && navigator.userAgent.match(/iPhone/i) !== null && navigator.userAgent.match(/Android/i) == null;
	window.isAndroid = window.isTouch && !window.isiPad && !window.isiPhone && navigator.userAgent.match(/Android/i) !== null;
	window.isSafariDesktop = isSafari() && !isiPhone && !isiPad;

	if (isMobile) {
		window.$html.classList.add("mobile");
		if (isiPhone) {
			window.$html.classList.add("iphone");
		}

	} else if (isTablet) {
		window.$html.classList.add("tablet");
		if (isiPad) {
			window.$html.classList.add("ipad");

		}
	} else {
		window.$html.classList.add("desktop");
	}

	if (isMobile || isTablet) {
		$html.classList.remove("landscape");
		$html.classList.remove("portrait");
		$html.classList.add(getOrientation());
		window.addEventListener("orientationchange", function () {
			$html.classList.remove("landscape");
			$html.classList.remove("portrait");

			$html.classList.add(getOrientation());
		}, false);
	}

	if (isAndroid) {
		window.$html.classList.add("android");
	}

	if (hasTransitions) {
		window.$html.classList.add("transitions");
	}

	if ('download' in createElement('a')) {
		window.$html.classList.add("download");
	}

	if (/*@cc_on!@*/false) {
		window.$html.classList.add("ie");
		window.$html.classList.add("ie10");
	}

	if (!(window.ActiveXObject) && "ActiveXObject" in window) {
		window.$html.classList.add("ie");
		window.$html.classList.add("ie11");
	}

	if (window.isEdge) {
		window.$html.classList.add("ie");
		window.$html.classList.add("edge");
	}

	window.$html.classList.add(isTouch ? "touch" : "no-touch");

	if (isAndroid) {
		// keyboard pushing site up fix
		setTimeout(function () {
			var viewheight = window.innerHeight;
			var viewwidth = window.innerWidth;
			var viewport = document.querySelector("meta[name=viewport]");
			viewport.setAttribute("content", "height=" + viewheight + "px, width=" + viewwidth + "px, initial-scale=1.0");
		}, 500);
	}
})();




//////////////////
// WEBPACK FOOTER
// ./src/js/detection.js
// module id = 9
// module chunks = 0